// extracted by mini-css-extract-plugin
export default {"loaderFullScreen":"loader_loaderFullScreen__uifSs","loader":"loader_loader__DK7CN","spin":"loader_spin__0eidw"};